import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class ImageWithLoader extends React.PureComponent {
	constructor() {
		super();
		this.state = {
			loading: true,
			initialLoading: true,
			oldSrc: '',
		};
		this.displayImage = this.displayImage.bind(this);
		this.getClassNames = this.getClassNames.bind(this);
	}
	componentDidMount() {
		this.fetchImage();
	}
	componentWillReceiveProps(nextProps) {
		if (this.props.src !== nextProps.src) {
			this.fetchImage();
		}
	}
	fetchImage() {
		if (this.props.src) {
			this.setState(() => ({
				loading: true,
				oldSrc: this.props.src,
			}), () => {
				const img = new window.Image();
				img.onload = () => {
					this.displayImage();
				};
				img.src = this.props.src;
			});
		}
	}
	displayImage() {
		this.setState(() => ({
			loading: false,
			initialLoading: false,
		}));
	}
	getClassNames() {
		return classnames('product__image', {
			'product__image--is-loading': this.state.loading,
			'product__image--initial': this.state.initialLoading,
		});
	}
	render() {
		return (
			<div className={this.getClassNames()}>
				<img
					src={this.state.loading ? this.state.oldSrc : this.props.src}
					alt={this.props.alt}
				/>
				<div className="spinner" />
			</div>
		);
	}
}

ImageWithLoader.propTypes = {
	src: PropTypes.string.isRequired,
	alt: PropTypes.string.isRequired,
};

export default ImageWithLoader;



// WEBPACK FOOTER //
// ./src/components/Site/Shop/ImageWithLoader.js